module.exports = __webpack_public_path__ + "media/application/images/home/home-background-62f8f54d9896709160099866e2968ff4.jpg";